import { Helper } from '../../Helper';
export class PickObjectPropertiesHelper extends Helper {
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.createObject);
        sb.emitOp(node, 'TUCK');
        sb.emitPushInt(node, 4);
        sb.emitOp(node, 'PICK');
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.pickPropertyObjectProperties);
        sb.emitOp(node, 'DUP');
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'XSWAP');
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.pickSymbolObjectProperties);
    }
}

//# sourceMappingURL=PickObjectPropertiesHelper.js.map
